/**
 * Labstep
 *
 * @module components/EntityUserRole/EditModal
 * @desc Edit Modal for EntityUserRole
 */

import { EntityFormShowEditDescription } from 'labstep-web/components/Entity/Form/ShowEdit/Description';
import { EntityFormShowEditName } from 'labstep-web/components/Entity/Form/ShowEdit/Name';
import { Button } from 'labstep-web/core/Button';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { HorizontalTable } from 'labstep-web/core/Table/Horizontal';
import type { EntityUserRole } from 'labstep-web/models/entity-user-role.model';
import type React from 'react';
import styles from './styles.module.scss';
import type { EntityUserRoleEditModalProps } from './types';

export const EntityUserRoleEditModal: React.FC<
  EntityUserRoleEditModalProps
> = ({ entityUserRole, onClose }) => {
  return (
    <ModalDefault
      open
      onClose={onClose}
      header="Configure Role"
      className={styles.roleModal}
      viewComponent={null}
      content={() => (
        <HorizontalTable
          rows={[
            {
              header: 'Name',
              content: (role: EntityUserRole) => (
                <EntityFormShowEditName entity={role} />
              ),
            },
            {
              header: 'Description',
              content: (role: EntityUserRole) => (
                <EntityFormShowEditDescription entity={role} />
              ),
            },
          ]}
          columns={[entityUserRole]}
        />
      )}
      footer={() => (
        <Button primary onClick={onClose}>
          Done
        </Button>
      )}
    />
  );
};
